import { type GetHookResponse } from '../hooks'
import { questionsKey } from '../keys'
import { useTantalimQuery } from '../query'
import { DAY, HOUR, type QuestionData, type QuestionListInput, type QuestionListSuccess } from '@terros/common'

export function useQuestions(input: QuestionListInput = {}): GetHookResponse<QuestionData[]> {
  return useTantalimQuery<QuestionListInput, QuestionListSuccess, QuestionData[]>({
    url: '/question/manage/list',
    queryKey: questionsKey(input),
    input,
    convertResponse: (data) => data.questions,
    options: {
      gcTime: HOUR,
      staleTime: DAY,
    },
  })
}
